<template>
	<div class="progress">
		<div role="progressbar" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100" id="progress-bar" class="progress-bar progress-bar-success" :style="'width: ' + progress + '%;'"></div>
	</div>
</template>

<script>
	
	export default {
		name: 'ProgressBar',
		props: ['system', 'visited_pages'],
		computed: {
			progress: function() {
				return (this.visited_pages.length / this.system.pages.length) * 100;
			}
		}
	}

</script>

<style>
	div.progress {
		height: 5px;
		margin-bottom: 0;
		border-radius: 0;
	}
</style>